module.exports = __webpack_public_path__ + "4689027c0d91525faa970a4db8a87994.mp3";